export enum DayTypeEnum {
  ITINERARY_DAY_FORM = 'Formulario',
  ITINERARY_DAY_CONTENT = 'Contenido',
  ITINERARY_DAY_LINK = 'Link',
  ITINERARY_DAY_ACTIVITY = 'Actividad'
}
